module.exports = __webpack_public_path__ + "static/462678-cb9f84962244f0248a7db8957d973a2b.png";